
import React, { Component } from "react";
import Chart from "react-apexcharts";

class BarChart4 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: {
        chart: {
          id: "basic-bar",
          toolbar: { show: false }
        },
        colors: ["#4C99FF", "#FFC107"], // Example color palette
        xaxis: {
          categories: props?.categories,
          labels: {
            style: {
              colors: '#333',
              fontSize: '14px' // Increased font size
            }
          }
        },
        yaxis: {
          labels: {
            style: {
              colors: '#333',
              fontSize: '14px' // Increased font size
            }
          }
        },
        grid: {
          borderColor: '#e7e7e7',
          // Reduced number of gridlines
          row: {
            colors: ['#f3f3f3', 'transparent'],
            opacity: 0.2
          }
        },
        tooltip: {
          enabled: true,
          theme: "dark",
          backgroundColor: '#333', // Customized tooltip background
          bodyColor: '#fff', // Customized tooltip text color
          bodyFontSize: 12 // Increased tooltip font size
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ['#333']
          }
        },
        // Add animations (library specific)
        animation: {
          duration: 1000, // Animation duration in milliseconds
        },
        // Add gradients (library specific)
        plugins: {
          legend: {
            labels: {
              fontColor: '#333' // Customize legend text color
            }
          }
        }
      },
      series: [
        { name: props.seriesName || "", data: props?.seriesData || [] }
      ]
    };
  }

  render() {
    return (
      <div className="app">
        <div className="row">
          <div className="mixed-chart"  style={{width:"98%"}}>
            <Chart
              options={this.state.options}
              series={this.state.series}
              type="line"
              height="260"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default BarChart4;

